import { render, staticRenderFns } from "./tvr_report.vue?vue&type=template&id=99d94cd8&scoped=true"
import script from "./tvr_report.vue?vue&type=script&lang=js"
export * from "./tvr_report.vue?vue&type=script&lang=js"
import style0 from "./tvr_report.vue?vue&type=style&index=0&id=99d94cd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d94cd8",
  null
  
)

export default component.exports